"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTReturn = void 0;
const immutable_1 = require("immutable");
exports.OTReturn = (0, immutable_1.Record)({
    periods: (0, immutable_1.List)(),
    txns: (0, immutable_1.List)(),
    currency: '',
});
